var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMinusIcon = function SvgMinusIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-solid:plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.10156 7.20035C9.10156 7.20035 8.55469 7.2002 8.00156 7.2002C7.44844 7.2002 7.10156 7.20035 7.10156 7.20035L2.60156 7.2002C2.04844 7.2002 1.60156 7.64707 1.60156 8.2002C1.60156 8.75332 2.04844 9.2002 2.60156 9.2002H7.10156C7.10156 9.2002 7.52585 9.2002 8.07897 9.2002C8.6321 9.2002 9.10156 9.2002 9.10156 9.2002H13.6016C14.1547 9.2002 14.6016 8.75332 14.6016 8.2002C14.6016 7.64707 14.1547 7.2002 13.6016 7.2002L9.10156 7.20035Z",
    fill: "#828282"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMinusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "minus-icon.bd90f3ea1279f67ae44e9c48d33379ab.svg";